import { NAV_HEIGHT_SCROLL_VALUE, NAV_HEIGHT_SHEF_MENU_SCROLL_VALUE, NAV_HEIGHT_VALUE } from './consts';

export const getNavScrollDistance = ({ isShefMenu = false }: { isShefMenu?: boolean } = {}) => {
  const maxScrollDistance = isShefMenu ? NAV_HEIGHT_SHEF_MENU_SCROLL_VALUE : NAV_HEIGHT_SCROLL_VALUE;
  return window.pageYOffset >= maxScrollDistance ? maxScrollDistance : 1;
};

export const checkElementHeight = (el, isSmallScreen, buffer = 0) => {
  if (!el) return false;
  const { top, bottom } = el.getBoundingClientRect();
  const valueToCompare = isSmallScreen ? bottom : top;
  return valueToCompare <= NAV_HEIGHT_VALUE + buffer;
};
